const FILTER_STORAGE_PREFIX = 'tab:filters:';

function storageKey(userId: number, scope: string): string {
  return `${FILTER_STORAGE_PREFIX}${userId}:${scope}`;
}

export function readFilterPreference<T>(userId: number, scope: string, fallback: T): T {
  try {
    const stored = localStorage.getItem(storageKey(userId, scope));
    if (stored === null) return fallback;
    return JSON.parse(stored) as T;
  } catch {
    return fallback;
  }
}

export function writeFilterPreference(userId: number, scope: string, value: unknown): void {
  try {
    localStorage.setItem(storageKey(userId, scope), JSON.stringify(value));
  } catch {
    // Filters still work in-memory when storage is unavailable or full.
  }
}

export function clearFilterPreferences(userId: number): void {
  try {
    const prefix = `${FILTER_STORAGE_PREFIX}${userId}:`;
    const keys = Array.from({ length: localStorage.length }, (_value, index) => localStorage.key(index))
      .filter((key): key is string => Boolean(key?.startsWith(prefix)));
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Storage may be disabled by browser policy.
  }
}
